import React from 'react';
import { PrimaryButton } from '@workday/canvas-kit-react/button';
import { autoId } from '@workday/upc-common';
import { ID_RESET_PASSWORD_SEND_TOTP } from '../../../autoIds';
import styles from './confirm-email.module.scss';
import { useSelector } from 'react-redux';
import { selectUserEmail } from '../../../slices/login.slice';
import { LoginLink } from '../../../shared/login-link/login-link';
import { maskEmail } from '../../../utils/string';
import { useHistory } from 'react-router-dom';
import { RESET_PASSWORD_VERIFY_AUTHENTICATOR_PATH } from '../../../react-router-paths';
import { useTranslation } from 'react-i18next';

export function ConfirmEmail() {
    const history = useHistory();

    const { t } = useTranslation('auth');

    const userEmail = useSelector(selectUserEmail);

    function onResetPasswordClick() {
        history.push(RESET_PASSWORD_VERIFY_AUTHENTICATOR_PATH);
    }

    return (
        <div className={styles.resetPasswordEmailEntry}>
            <h1 className={styles.title}>{t('ConfirmEmail.title')}</h1>
            <p className={styles.body}>{t('ConfirmEmail.description')}</p>
            <p className={styles.email}>{maskEmail(userEmail)}</p>
            <PrimaryButton
                onClick={onResetPasswordClick}
                {...autoId(ID_RESET_PASSWORD_SEND_TOTP)}
                size='large'
                grow={true}
                marginBottom='1rem'>
                {t('ConfirmEmail.submitButton')}
            </PrimaryButton>
            <LoginLink />
        </div>
    );
}
